import { render, staticRenderFns } from "./index_item.vue?vue&type=template&id=ecf80f7a&scoped=true&"
import script from "./index_item.vue?vue&type=script&lang=js&"
export * from "./index_item.vue?vue&type=script&lang=js&"
import style0 from "./index_item.vue?vue&type=style&index=0&id=ecf80f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf80f7a",
  null
  
)

export default component.exports